import { LitElement, html, unsafeCSS } from "lit"
import { customElement, property } from "lit/decorators.js"
import gridStyles from "./styles/ephemeris-grid.css?inline"
import cellStyles from "./styles/ephemeris-table-header.css?inline"

/**
 * Ephemeris table header component.
 * Renders as a single row with 12 column headers using the shared grid definition.
 */
@customElement("ephemeris-table-header")
export class EphemerisTableHeader extends LitElement {
  @property({ type: String }) obsLabel = ""
  @property({ type: String }) localLabel = ""

  static styles = [unsafeCSS(gridStyles), unsafeCSS(cellStyles)]

  protected render() {
    return html`
      <span role="columnheader" class="header-cell">⚡</span>
      <span role="columnheader" class="header-cell">📅 Date</span>
      <span role="columnheader" class="header-cell">🌍 Time</span>
      <span role="columnheader" class="header-cell">${this.obsLabel}</span>
      <span role="columnheader" class="header-cell">${this.localLabel}</span>
      <span role="columnheader" class="header-cell">🌆 Dark</span>
      <span role="columnheader" class="header-cell">🧭 AZI</span>
      <span role="columnheader" class="header-cell">📶 ELEV</span>
      <span role="columnheader" class="header-cell">➡️ RA</span>
      <span role="columnheader" class="header-cell">⬆️ DEC</span>
      <span role="columnheader" class="header-cell">🌑 Moon</span>
      <span role="columnheader" class="header-cell">🌕 Phase</span>
    `
  }
}


